var ActionformAbstract = function ($) {

    // Abstract class
    var Self = ActionformAbstract = function () {
    };
    Self.className = 'ActionformAbstract';

    var def = function (var1, var2) {
        for (var i = 0, len = arguments.length; i < len; i++) {
            if (typeof arguments[i] !== 'undefined') {
                return arguments[i];
            }
        }
        return undefined;
    };

    Self.def = def;

    Self.prototype.init = function (options) {
        var that = this;

        that.initVars(options);
        that.initCallbacks(options);
        that.initEventHandlers();

        that.afterInit();
    };

    Self.prototype.afterInit = function () {
        var that = this;

        $.sa.$document.trigger(
            that.events.action_initialized,
            {
                $action: that.$form
            }
        );
    };

    Self.prototype.initVars = function (options) {
        var that = this;

        options = options || {};

        that.selectors = that.selectors || {};
        // TODO: setting `next_action` and `previous_action` from `options` would be used after other signup/password restoration methods would be done
        that.selectors.next_action = def(options.next_action, that.selectors.next_action, '');
        that.selectors.previous_action = def(options.previous_action, that.selectors.previous_action, '');

        that.selectors = $.extend({

            form: 'form',
            form_input: '.input',
            form_input_error: '.error',
            form_wrapper: '.js-form-wrapper',
            form_title: '.js-title',

            modal: '.modal',
            modal_header_title: '.modal-header-title',
            modal_content: '.js-actionform-modal-content',

            success_wrapper: '.js-success-wrapper',
            success_sent_to: '.js-sent-to',

            button_submit: '.js-button-submit',
            button_back: '.js-button-back',
            button_goto: '.js-goto-button',

            error_alert: '.js-error-alert',
            error_alert_title: '.js-error-alert-title',
            error_alert_content: '.js-error-alert-content',
            error_msg: '.js-error-msg'

        }, that.selectors);

        that.classes = that.classes || {};
        that.classes = $.extend({

            button_loading: 'loading',
            error_input: 'error',
            error_alert_hidden: 'hidden',
            wrapper_hidden: 'hidden',
            button_hidden: 'hidden',
            modal_animation: 'animation',

        }, that.classes);

        that.data_keys = that.data_keys || {};
        that.data_keys = $.extend({

            form_action: 'action'

        }, that.data_keys);

        that.events = that.events || {};
        that.events = $.extend({
                action_initialized: 'avia_actionform_action_initialized',
                action_shown: 'avia_actionform_action_shown'
            },
            that.events
        );

        // DOM
        that.$wrapper = def(that.$wrapper, options.$wrapper, $());

        that.initDomElements();

        // CONST
        that.locales = def(options.locales, that.locales, {});
        // that.js_validate = def(that.js_validate, options.js_validate, true);
        that.is_ajax_mode = def(options.is_ajax_mode, that.is_ajax_mode);
        that.is_modal_mode = def(options.is_modal_mode, that.is_modal_mode);
        that.has_success_screen = def(that.has_success_screen, false);
        that.className = def(that.className, Self.className);
        that.url = def(options.url, that.url, that.getFormAction(), '');

        that.method = def(options.method, that.method, 'POST');
        that.next_url = def(options.next_url, that.next_url, null); // set it as empty string to reload current page

        // DYNAMIC VARS
        that.errors = def(that.errors, options.errors, {});
    };

    Self.prototype.initDomElements = function () {
        var that = this;
        that.$form = that.$wrapper.find(that.selectors.form);
        if (!that.$form.length) {
            that.$form = that.$wrapper.find('form');
        }
        if (!that.$form.length) {
            that.$form = $();
        }

        that.$form_wrapper = that.$wrapper.find(that.selectors.form_wrapper);
        that.$success_wrapper = that.$wrapper.find(that.selectors.success_wrapper);

        // for modal mode
        that.$modal = that.$wrapper.parents(that.selectors.modal);
        that.$modal_title = that.$modal.find(that.selectors.modal_header_title);
        that.$modal_content = that.$modal.find(that.selectors.modal_content);

        if (that.selectors.next_action) {
            if (that.isModalMode()) {
                that.initNextAction(that.$modal_content.find(that.selectors.next_action))
            } else {
                that.initNextAction($.sa.$document.find(that.selectors.next_action));
            }
        }

        if (that.selectors.previous_action) {
            if (that.isModalMode()) {
                that.initPreviousAction(that.$modal_content.find(that.selectors.previous_action))
            } else {
                that.initPreviousAction($.sa.$document.find(that.selectors.previous_action));
            }
        }

        that.$form_button_back = that.$form_wrapper.find(that.selectors.button_back);
        that.$form_button_submit = that.$form.find(that.selectors.button_submit) || that.$form.find(':submit');
        that.$success_button_back = that.$success_wrapper.find(that.selectors.button_back);
        that.$success_button_confirm = that.$success_wrapper.find(that.selectors.button_submit); // optional
        that.$button_goto = that.$form.find(that.selectors.button_goto);

        that.$error_alert = that.$wrapper.find(that.selectors.error_alert);
        that.$error_alert_title = that.$wrapper.find(that.selectors.error_alert_title);
        that.$error_alert_content = that.$wrapper.find(that.selectors.error_alert_content);
    }

    Self.prototype.initNextAction = function ($action) {
        var that = this;

        that.$next_action = $action;
    };

    Self.prototype.initPreviousAction = function ($action) {
        var that = this;

        that.$previous_action = $action;
    };

    Self.prototype.initEventHandlers = function () {
        var that = this;
        that.$form_button_submit.on('click', function (e) {
            that.onSubmit(e);
        });
        that.$success_button_confirm.on('click', function (e) {
            that.closeModal();
        });
        that.$success_button_back.on('click', function (e) {
            that.backFromSuccess();
        });
        that.$form_button_back.on('click', function (e) {
            that.toPreviousAction();
        });
        that.$button_goto.on('click', function (e) {
            e.preventDefault();
            that.toAction($(this).data('goto'));
        });
        that.$form.on(that.events.action_shown, function () {
            that.onActionShown();
        });
        
        // sometimes, there could be multiple connected screens in non-modal mode, but acting like modal (sliding to next/previous action etc);
        // and it's possible that some action's DOM is not inserted yet while another action component is already initialized,
        // so its $next_action would be undefined in that case.
        // So, trigger event after component init, catch it and set next (or maybe previous) action.
        $.sa.$document.on(that.events.action_initialized, function (e, data) {
            var $action = data.$action;

            if (!$action || !$action.length || !($action instanceof jQuery)) {
                return;
            }

            if (that.selectors.next_action && $action.is(that.selectors.next_action) && !that.$next_action.length) {
                that.initNextAction($action);
            } else if (that.selectors.previous_action && $action.is(that.selectors.previous_action) && !that.$previous_action.length) {
                that.initPreviousAction($action);
            }
        });
    };

    Self.prototype.initCallbacks = function (options = {}) {
        var that = this;

        that.beforeMoveToNextAction = def(options['beforeMoveToNextAction'], that.beforeMoveToNextAction, function () {});
        that.beforeMoveToSuccess = def(options['beforeMoveToSuccess'], that.beforeMoveToSuccess, function () {});
    };

    Self.prototype.onSubmit = function (e) {
        var that = this;
        if (!that.is_ajax_mode) {
            return;
        }
        e.preventDefault();
        return that.submit();
    };

    Self.prototype.submit = function (options) {
        options = options || {};

        var that = this;

        that.beforeSubmit();

        that.clearErrors();

        // TODO: validate (?)
        // if (that.js_validate) {
        //     var errors = that.validate();
        //     if (!$.isEmptyObject(errors)) {
        //         that.showErrors(errors);
        //         return;
        //     }
        // }

        var $button = options.$button || that.$form_button_submit,
            url = options.url || that.url,
            method = options.method || that.method,
            data = that.getSerializedFormData();

        $button.addClass(that.classes.button_loading);
        $button.prop('disabled', true);

        return that.jsonSend(url, method, data)
            .done(function (response) {
                if (!that.isRedirectResponse(response) || !that.isResponseSuccessful(response)) {
                    // On 'redirect' response
                    // DO NOT hide loading and enable button right away
                    // for UI/UX reason
                    $button.prop('disabled', false);
                    $button.removeClass(that.classes.button_loading);
                }
                that.onDoneSubmit(response);
            })
            .fail(function (jqXHR) {
                $button.prop('disabled', false);
                $button.removeClass(that.classes.button_loading);
                that.onDoneSubmitHandleFail([
                    {
                        _alert: that.getLocalePhrase('error'),
                        message: jqXHR.responseText
                    }
                ], null);
            })
            .always(function (response) {
                that.onAlwaysSubmit(response);
            });
    };

    Self.prototype.beforeSubmit = function () {
        var that = this;

        var getCsrfToken = function() {
            var matches = document.cookie.match(new RegExp("(?:^|; )_csrf=([^;]*)"));
            if (!matches || !matches[1]) {
                return '';
            }
            return decodeURIComponent(matches[1]);
        };

        // Update csrf token right before submit
        // in case it changed via another browser tab
        var $csrf_hidden_field = that.$form.find('[name="_csrf"]');
        $csrf_hidden_field.val(getCsrfToken);
    };

    Self.prototype.onDoneSubmit = function (response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers(),
            ok = that.isResponseSuccessful(response),
            data = (response && response.data) || {},
            messages = data.messages || {},
            errors = (response && response.errors) || {},
            stop = false;

        if (!ok) {
            stop = that.onDoneSubmitHandleFail(errors, response);
            if (stop) {
                return;
            }
        }

        stop = that.onDoneSubmitHandleSuccess(response);
        if (stop) {
            return;
        }

        if (!$.isEmptyObject(messages)) {
            stop = (that.onDoneSubmitHandleMessages(messages, response));
            if (stop) {
                return;
            }
        }

        handlers.rest && handlers.rest(response);
    };

    Self.prototype.onDoneSubmitHandleSuccess = function (response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers();

        if (that.isRedirectResponse(response) || that.needRedirect()) {
            var url = that.getRedirectUrl(response);
            return (handlers.redirect && handlers.redirect(url));
        }
        else if (that.needGoToNext()) {
            return (handlers.goToNext && handlers.goToNext(response));
        }
        return false;
    };

    Self.prototype.onDoneSubmitHandleFail = function (errors, response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers();

        return (handlers.errors && handlers.errors(errors, response));
    };

    Self.prototype.onDoneSubmitHandleMessages = function (messages, response) {
        var that = this,
            handlers = that.onDoneSubmitHandlers();

        return (handlers.messages && handlers.messages(messages));
    };

    Self.prototype.onDoneSubmitHandlers = function () {
        var that = this;
        return {
            errors: function (errors, response) {
                that.showErrors(errors);
                return true;
            },
            redirect: function (url) {
                // if url is not string and empty (null for example) - do nothing
                if (!url && typeof url !== 'string') {
                    return;
                } else if (
                    url.length === 0 || // if url is undefined or empty, reload current page
                    (url.indexOf('#') !== -1 && url === window.location.href)
                ) {
                    window.location.reload();
                } else {
                    window.location.href = url;
                }
                return true;
            },
            goToNext: function(response) {
                if (that.hasSuccessScreen()) {
                    that.beforeMoveToSuccess(response);
                    that.toSuccess();
                } else {
                    that.beforeMoveToNextAction(response);
                    that.toNextAction();
                }
                return true;
            },
            messages: function (messages) {
                that.showInfoMessages(messages);
                return true;
            },
            rest: function (response) {
                return true;
            }
        };
    };

    Self.prototype.onAlwaysSubmit = function (response) {
        // TODO: captcha (?)
        // if (!that.isRedirectResponse(response)) {
        //     // Not need call redundant refresh request
        //     $('.wa-captcha-refresh').trigger('click');
        // }
    };

    Self.prototype.onActionShown = function () {
        var that = this;
        that.clearForm();
    };

    Self.prototype.clearForm = function () {
        var that = this,
            $form_inputs = that.getFormInputs().find('input');

        // clear errors
        that.clearErrors();
        // clear all inputs
        UIInput.prototype.clearInput($form_inputs);
        // enable all inputs
        UIInput.prototype.enable($form_inputs);
        // enable submit button
        that.toggleSubmitButtonAvailability(true);
    };

    Self.prototype.clearErrors = function () {
        var that = this;
        that.hideErrorAlert();
        that.hideErrorAlertTitle();
        that.clearInputErrors();
    }

    Self.prototype.showErrors = function (errors) {
        var that = this;
        errors = errors || [];
        if (errors.length > 0) {
            errors.forEach(function(error) {
                // so only one alert could be displayed (currently, it's the last one)
                that.setErrorAlert(
                    error.hasOwnProperty('_alert') ? error._alert : '',
                    error.hasOwnProperty('_title') ? error._title : ''
                );

                if (error.hasOwnProperty('_input') && error._input !== null) {
                    var input_errors = error._input;
                    for(var error_name in input_errors) {
                        var error_list = input_errors[error_name];
                        var res = that.displayInputErrors(error_name, error_list);
                        if (!res) {
                            that.displayUncaughtErrors(error_name, error_list);
                        }
                    }
                }

                if (
                    !error.hasOwnProperty('_alert') &&
                    !error.hasOwnProperty('_input') &&
                    error.hasOwnProperty('message')
                ) {
                    that.displayUncaughtErrors('unknown', error.message);
                }
            });
        }
    }

    Self.prototype.setErrorAlert = function (error_text = '', error_title = '') {
        var that = this;

        if (error_title) {
            that.setErrorAlertTitle(error_title);
            that.showErrorAlertTitle();
        } else {
            that.hideErrorAlertTitle();
        }

        if (error_text) {
            that.setErrorAlertText(error_text);
            that.showErrorAlert();
        } else {
            that.hideErrorAlert();
        }
    }

    Self.prototype.showErrorAlert = function () {
        this.$error_alert.removeClass(this.classes.error_alert_hidden);
    }

    Self.prototype.hideErrorAlert = function () {
        this.$error_alert.addClass(this.classes.error_alert_hidden);
    }

    Self.prototype.setErrorAlertText = function (error_text = '') {
        this.$error_alert_content.html(error_text);
    }

    Self.prototype.setErrorAlertTitle = function (error_title = '') {
        this.$error_alert_title.html(error_title);
    }

    Self.prototype.showErrorAlertTitle = function () {
        this.$error_alert_title.removeClass(this.classes.error_alert_hidden);
    }

    Self.prototype.hideErrorAlertTitle = function () {
        this.$error_alert_title.addClass(this.classes.error_alert_hidden);
    }

    Self.prototype.prepareInputErrorText = function (error_text = '') {
        var that = this;

        // if error_text is `false` - do not display error message
        if (error_text === false) {
            return '';
        }
        // if error_text is empty - set default input error text
        else if (error_text.length === 0) {
            return that.getLocalePhrase('error');
        } else {
            return error_text;
        }
    };

    Self.prototype.setInputErrors = function ($input, errors) {
        var that = this;

        errors = errors.map(error_text => that.prepareInputErrorText(error_text));

        UIInput.prototype.appendErrors($input, errors);
    };

    Self.prototype.displayInputErrors = function (name, error_list) {
        var that = this,
            $input = that.getFormInput(name);
        if (!$input.length) {
            return false;
        }

        if (!Array.isArray(error_list)) {
            error_list = [error_list];
        }
        that.setInputErrors($input, error_list);

        return true;
    }

    Self.prototype.clearInputErrors = function () {
        var that = this,
            $inputs = that.getFormInputs().find('input');
        UIInput.prototype.clearError($inputs);
    };

    Self.prototype.displayUncaughtErrors = function (name, errors) {
        // TODO: define
        var that = this,
            error_text = '';
        if (Array.isArray(errors)) {
            errors.forEach(function (error) {
                error_text += error.message + '; ';
            });
        } else {
            error_text += errors;
        }
        $.sa.error(`Uncaught error "${name}": ${error_text}`);
    }

    Self.prototype.showInfoMessages = function (messages) {
        // TODO: define
    }

    Self.prototype.isModalMode = function () {
        return this.is_modal_mode;
    };

    // for those actions that require redirect even in modal mode -
    // they should override this property;
    // by default, redirect is needed in non-modal mode
    Self.prototype.needRedirect = function () {
        return !this.isModalMode();
    };

    // for those actions that require showing next screen even in non-modal mode -
    // they should override this property;
    // by default, moving to the next screen is needed in modal mode
    Self.prototype.needGoToNext = function () {
        return this.isModalMode();
    };

    Self.prototype.hasSuccessScreen = function () {
        return this.has_success_screen;
    };

    Self.prototype.jsonSend = function (url, method, data) {
        if (!url) return null;
        return $.ajax(url, {method: method, data: data, dataType: 'json'});
    }

    Self.prototype.isResponseSuccessful = function (response) {
        return response && response.status === 'ok';
    }

    Self.prototype.isRedirectResponse = function (response) {
        return this.getRedirectUrl(response) !== null;
    };

    Self.prototype.getRedirectUrl = function (response) {
        var that = this,
            url = that.getRedirectUrlFromResponse(response);

        if (typeof url === 'string') {
            return url;
        } else if (typeof that.next_url === 'string') {
            return that.next_url;
        } else {
            return null;
        }
    };

    Self.prototype.getRedirectUrlFromResponse = function (response) {
        var that = this;

        return that.isResponseSuccessful(response) && response.data && response.data.redirect_url
            ? response.data.redirect_url
            : null;
    };

    Self.prototype.toNextAction = function () {
        var that = this,
            $next_action_wrapper = that.$next_action.parents(that.selectors.form_wrapper);
        that._animateGoTo(that.$form_wrapper, $next_action_wrapper, 'forward');
        that._showAction(that.$next_action);
        that._showBackButton(that.$next_action);
        that.$next_action.trigger(that.events.action_shown);
    };

    Self.prototype.toPreviousAction = function () {
        var that = this,
            $previous_action_wrapper = that.$previous_action.parents(that.selectors.form_wrapper);
        that._animateGoTo(that.$form_wrapper, $previous_action_wrapper, 'back');
        that._showAction(that.$previous_action);
        that.$previous_action.trigger(that.events.action_shown);
    };

    Self.prototype.toAction = function (action_class) {
        var that = this,
            $action = that.isModalMode()
                ? that.$modal_content.find('.' + action_class)
                : $.sa.$document.find('.' + action_class),
            $action_wrapper = $action.parents(that.selectors.form_wrapper);
        that._animateGoTo(that.$form_wrapper, $action_wrapper, 'forward');
        that._showAction($action);
        that._showBackButton($action);
        $action.trigger(that.events.action_shown);
    };

    Self.prototype._showAction = function ($action) {
        var that = this,
            $action_title = $action.find(that.selectors.form_title);
        that._setModalTitle($action_title.html());
    };

    Self.prototype._showBackButton = function ($action) {
        var that = this,
            $action_wrapper = $action.parents(that.selectors.form_wrapper),
            $action_back_button = $action_wrapper.find(that.selectors.button_back);
        $action_back_button.removeClass(that.classes.button_hidden);
    };

    Self.prototype.toSuccess = function () {
        var that = this;
        that._animateGoTo(that.$form_wrapper, that.$success_wrapper, 'forward');
    };

    Self.prototype.backFromSuccess = function () {
        var that = this;
        that._animateGoTo(that.$success_wrapper, that.$form_wrapper, 'back');
    };

    Self.prototype._animateGoTo = function ($elem_from, $elem_to, direction) {
        var that = this,
            animation_show_class,
            animation_hide_class;

        if (direction === 'forward') {
            animation_show_class = 'fadeInRight';
            animation_hide_class = 'fadeOutLeft';
        } else if (direction === 'back') {
            animation_show_class = 'fadeInLeft';
            animation_hide_class = 'fadeOutRight';
        } else {
            return;
        }

        that.$modal_content.addClass(that.classes.modal_animation);

        $elem_from.removeClass(that.classes.wrapper_hidden)
            .addClass('animated')
            .addClass('faster')
            .removeClass(animation_show_class)
            .addClass(animation_hide_class);

        $elem_to.removeClass(that.classes.wrapper_hidden)
            .addClass('animated')
            .addClass('faster')
            .removeClass(animation_hide_class)
            .addClass(animation_show_class);

        $elem_from.addClass(that.classes.wrapper_hidden);

        setTimeout(function () {
            that.$modal_content.removeClass(that.classes.modal_animation);
            // clear animation classes
            $elem_from.removeClass(animation_hide_class).removeClass('animated').removeClass('faster');
            $elem_to.removeClass(animation_show_class).removeClass('animated').removeClass('faster');
        }, 500);
    };

    Self.prototype._setModalTitle = function (title) {
        var that = this;
        that.$modal_title.html(title);
    };

    Self.prototype.closeModal = function () {
        var that = this;

        if (that.isModalMode()) {
            that.$modal.data('modal').close();
        }
    };

    Self.prototype.getFormAction = function () {
        var that = this;
        if (that.$form.is('form')) {
            return that.$form.attr('action');
        } else {
            return that.$form.data(that.data_keys.form_action);
        }
    };

    /**
     * Set of form inputs could be changed dynamically,
     * so it must be better decision to get them dynamically, not on init
     */
    Self.prototype.getFormInputs = function () {
        var that = this;
        return that.$form.find(that.selectors.form_input);
    }

    Self.prototype.getFormInput = function (name) {
        var that = this;
        return that.$form.find('[name="' + name + '"]');
    }

    Self.prototype.getSerializedFormData = function () {
        var that = this;
        if (that.$form.is('form')) {
            return that.$form.serializeArray();
        } else {
            return that.$form.find(':input').serializeArray();
        }
    };

    /**
     * Returns locale phrase by provided phrase key.
     * Default phrase could be specified. It would be returned, if phrase was not found.
     *
     * At first, searches through `that.locales`,
     * if phrase is not found, searches through `$.sa.locales`,
     * if phrase is still not found, returns default phrase, if specified.
     * If default phrase is not specified, returns default fallback string. 
     *
     * @param {string} key Key for the locales object
     * @param {*} default_phrase String, which would be returned, if phrase was not found by specified key.
     * @return {string|*}
     */
    Self.prototype.getLocalePhrase = function (key, default_phrase = '') {
        var that = this,
            key_parts = key.split('.'),
            phrase;

        var searchPhrase = function (key_parts, locales) {
            var phrase = '';

            for (var key_part of key_parts) {
                var source = (phrase && typeof phrase === 'object') ? phrase : locales;

                if (source.hasOwnProperty(key_part)) {
                    phrase = source[key_part];
                } else {
                    phrase = '';
                    break;
                }
            }
            return phrase;
        }
        
        phrase = searchPhrase(key_parts, that.locales);
        if (!phrase) {
            phrase = searchPhrase(key_parts, $.sa.locales);
        }
        
        if (phrase) {
            return phrase;
        } else if (default_phrase) {
            // if default phrase is empty, consider that default phrase was not provided
            return default_phrase;
        } else {
            return '[' + $.sa.locales['no_text'] + ']';
        }
    }
    
    Self.prototype.isValidForm = function () {
        return true;
    };

    Self.prototype.toggleSubmitButtonAvailability = function (is_available) {
        var that = this;

        that.$form_button_submit.prop('disabled', !is_available);
    };

    Self.prototype.isActionActive = function () {
        var that = this;

        return !that.$form_wrapper.hasClass(that.classes.wrapper_hidden);
    };

    Self.prototype.isSuccessScreenActive = function () {
        var that = this;

        return !that.$success_wrapper.hasClass(that.classes.wrapper_hidden);
    };

    return Self;
}(jQuery);
